// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__310Nh","modalForm":"UpgradeEpcsModal_modalForm__3Fzzl","modalFooter":"UpgradeEpcsModal_modalFooter__RJdeE"};